"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
// 公開範囲 (1: 一般公開, 2: 公開, 3: 非公開)
const SCOPE_LIST = [1, 2, 3];
/**
 * Creative Entity.
 *
 * @desc constructorをprivateにしているため、fromJSONからのみinstance化が可能。
 *
 * @example <caption>fromJSONからinstance化</caption>
 * Creative.fromJSON({...})
 *
 * @example <caption>new からはできない。</caption>
 * new Creative({...}) // instance化できない
 */
class Creative {
    constructor({ id, fileUrl, height, industry, thumbnailUrl, width, contentType, fileSize, fileUpdatedAt, optimizerId, organizationId, scope, service, tag, organizationTag, placement, aspectRatio, duration, composition, optimizerProfileImageUrl, favorite, }) {
        this.id = id;
        this.contentType = contentType;
        this.fileSize = fileSize;
        this.organizationId = organizationId;
        this.optimizerId = optimizerId;
        this.fileUrl = fileUrl;
        this.fileUpdatedAt = fileUpdatedAt;
        this.width = width;
        this.height = height;
        this.thumbnailUrl = thumbnailUrl;
        this.tag = tag;
        this.organizationTag = organizationTag;
        this.industry = industry;
        this.service = service;
        this.scope = scope;
        this.placement = placement;
        this.aspectRatio = aspectRatio;
        this.duration = duration;
        this.composition = composition;
        this.optimizerProfileImageUrl = optimizerProfileImageUrl;
        this.favorite = favorite;
    }
}
Creative.fromJSON = (json) => {
    const { id, contentType, fileSize, organizationId, optimizerId, fileUrl, fileUpdatedAt, width, height, thumbnailUrl, tag, organizationTag, industry, service, scope, placement, aspectRatio, duration, composition, optimizerProfileImageUrl, favorite, } = Object.assign({}, json);
    if (typeof id !== 'string') {
        throw new Error('.id must be a string');
    }
    if (typeof contentType !== 'string') {
        throw new Error('.contentType must be a string');
    }
    if (typeof fileSize !== 'number') {
        throw new Error('.fileSize must be a number');
    }
    if (typeof organizationId !== 'number') {
        throw new Error('.organizationId must be a number');
    }
    if (optimizerId && typeof optimizerId !== 'number') {
        throw new Error('.optimizerId must be a number');
    }
    if (fileUrl && typeof fileUrl !== 'string') {
        throw new Error('.fileUrl must be a string');
    }
    const _fileUpdatedAt = luxon_1.DateTime.fromISO(fileUpdatedAt);
    if (typeof width !== 'number') {
        throw new Error('.width must be a number');
    }
    if (typeof height !== 'number') {
        throw new Error('.height must be a number');
    }
    if (thumbnailUrl && typeof thumbnailUrl !== 'string') {
        throw new Error('.thumbnailUrl must be a string');
    }
    if (tag && !Array.isArray(tag)) {
        throw new Error('.tag must be a Array');
    }
    if (organizationTag && !Array.isArray(organizationTag)) {
        throw new Error('.organization_tags must be a Array');
    }
    if (industry && !Array.isArray(industry)) {
        throw new Error('.industry must be a Array');
    }
    // TODO: この決め打ちの意図を確認すること
    if (!['ad'].includes(service)) {
        throw new Error('.service must be a "ad"');
    }
    if (scope && !SCOPE_LIST.includes(scope)) {
        throw new Error('.scope must be a 1 or 2 or 3');
    }
    if (![0, 1].includes(favorite)) {
        throw new Error('.favorite must be a 0 or 1');
    }
    return new Creative({
        id,
        fileUrl,
        height,
        industry,
        thumbnailUrl,
        width,
        contentType,
        fileSize,
        fileUpdatedAt: _fileUpdatedAt,
        optimizerId,
        organizationId,
        scope,
        service,
        tag,
        organizationTag,
        placement,
        aspectRatio,
        duration,
        composition,
        optimizerProfileImageUrl,
        favorite,
    });
};
exports.default = Creative;
